import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Flame, Star, X, HeartPulse } from "lucide-react";
import { api } from "@/lib/api";

export const SpotlightStrip = () => {
  const [stars, setStars] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/creators").then((r) => setStars(r.data.filter((c) => c.featured))).catch(() => {}); }, []);
  if (!stars.length) return null;
  return (
    <div data-testid="discover-spotlight" className="mb-6">
      <div className="overline mb-3 flex items-center gap-2"><Star size={12} className="text-[#D4AF37]" /> This month's spotlight</div>
      <div className="flex gap-4 overflow-x-auto pb-1">
        {stars.map((c) => (
          <button key={c.id} data-testid={`spotlight-${c.id}`} onClick={() => navigate(`/creator/${c.id}`)}
            className="flex flex-col items-center gap-2 flex-shrink-0 group">
            <div className="w-16 h-16 rounded-full p-[2px] gold-gradient transition-transform group-hover:scale-105">
              <div className="w-full h-full rounded-full overflow-hidden bg-[#1A1A1A]">
                {c.photos?.[0] && <img src={c.photos[0]} alt={c.name} className="w-full h-full object-cover" />}
              </div>
            </div>
            <span className="text-xs text-white max-w-[72px] truncate">{c.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const FantasyFilter = ({ selected, onChange }) => {
  const [groups, setGroups] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/fantasies").then((r) => setGroups(r.data)).catch(() => {}); }, []);
  const toggle = (item) => onChange(selected.includes(item) ? selected.filter((x) => x !== item) : [...selected, item]);
  return (
    <div className="mb-6" data-testid="fantasy-filter">
      <div className="flex items-center gap-2 flex-wrap">
        <button data-testid="fantasy-filter-toggle" onClick={() => setOpen((o) => !o)}
          className={`text-sm px-4 py-2 rounded-full flex items-center gap-2 transition-colors ${selected.length ? "gold-gradient text-black font-medium" : "btn-outline-gold"}`}>
          <Flame size={14} /> {selected.length ? `Craving ${selected.length} fantas${selected.length === 1 ? "y" : "ies"}` : "Filter by fantasy"}
        </button>
        {selected.length > 0 && (
          <button data-testid="fantasy-filter-clear" onClick={() => onChange([])} className="text-xs text-[#A0A0A0] hover:text-white flex items-center gap-1">
            <X size={12} /> Clear
          </button>
        )}
      </div>
      {open && (
        <div data-testid="fantasy-filter-panel" className="pe-card rounded-2xl p-4 mt-3 space-y-3">
          <div className="text-xs text-[#A0A0A0]">What are you craving tonight? Show members who share any of these.</div>
          {groups.map((grp) => (
            <div key={grp.group}>
              <div className="text-xs text-white font-medium mb-2">{grp.emoji} {grp.group}</div>
              <div className="flex flex-wrap gap-2">
                {grp.items.map((item) => {
                  const on = selected.includes(item);
                  return (
                    <button key={item} data-testid={`filter-fantasy-${item}`} onClick={() => toggle(item)}
                      className={`text-xs px-3 py-1.5 rounded-full border transition-colors ${on ? "gold-gradient text-black font-medium border-transparent" : "border-[#2A2A2A] text-[#A0A0A0] hover:text-white hover:border-[#D4AF37]/50"}`}>
                      {item}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export const QuizCta = () => {
  const [done, setDone] = useState(true);
  const navigate = useNavigate();
  useEffect(() => { api.get("/quiz").then((r) => setDone(Object.keys(r.data.answers || {}).length > 0)).catch(() => {}); }, []);
  if (done) return null;
  return (
    <button data-testid="quiz-cta" onClick={() => navigate("/quiz")}
      className="w-full mb-6 rounded-2xl p-4 flex items-center justify-between gap-3 border border-[#D4AF37]/50 bg-[#D4AF37]/10 hover:bg-[#D4AF37]/15 transition-colors text-left">
      <span className="flex items-center gap-3">
        <HeartPulse size={20} className="text-[#D4AF37] flex-shrink-0" />
        <span><span className="block text-sm text-white font-medium">Take the 1-minute desire quiz</span>
          <span className="block text-xs text-[#A0A0A0]">See how compatible you are with every member</span></span>
      </span>
      <span className="text-sm text-[#D4AF37] font-semibold whitespace-nowrap">Start →</span>
    </button>
  );
};
